import React from 'react';
import styled from 'styled-components';
import _map from 'lodash/map';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { Select, Option } from 'components/core/select';

const additionalOptionsMenuProps = {
  PaperProps: { style: { width: 'auto', minWidth: 85, marginTop: 12 } },
};

export default function AdditionalOptionsSelect({ onChange, value, options }) {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <StyledSelect
      MenuProps={additionalOptionsMenuProps}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      renderValue={(option) => (option.length > 12 && isMobileView ? `${option.substring(0, 12)}...` : option)}
    >
      {_map(options, (opt) => (
        <NarrowOption key={opt} value={opt}>
          {opt}
        </NarrowOption>
      ))}
    </StyledSelect>
  );
}

const NarrowOption = styled(Option)`
  height: 35px;
  min-height: 0;
`;

const StyledSelect = styled(Select)`
  width: auto;
  min-width: 100px;
  height: 53px;
  margin-right: 15px;
  border-radius: 32px !important;
  font-size: 18px;

  svg {
    right: 18px;
    margin-top: 8px;
  }

  & .MuiSelect-root {
    padding-right: 51px !important;
    border-radius: 32px !important;
  }

  & .MuiSelect-select:focus {
    background-color: inherit;
  }

  & .MuiOutlinedInput-input {
    font-size: 18px;
  }
`;
